export function buildQuillEditorModules(token: string) {
  return {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
    languageTool: {
      server: "/api/languagetool/inline",
      language: "de-AT",
      cooldownTime: 2000,
      showLoadingIndicator: true,
      disableNativeSpellcheck: false,
      apiOptions: { token },
    },
  };
}
